import { hotRank } from "@/mocks/heiliao";

const badge: Record<string, string> = {
  实锤: "bg-primary-100 text-primary-700",
  存疑: "bg-accent-100 text-accent-900",
  反转: "bg-secondary-200 text-secondary-900",
  进展: "bg-secondary-100 text-secondary-800",
  辟谣: "bg-background-200 text-foreground-600",
};

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  new: "ri-sparkling-2-line",
};

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-50 py-10 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-fire-fill text-sm"></i>吃瓜热度榜
            </div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              谁被聊得最多
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-500">
            热度只反映「被讨论的量」，不代表被证明。真正的结论请回到上面每一份证据链里核对。
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200 bg-background-100/70">
          {hotRank.map((r, i) => (
            <a
              key={r.rank}
              href="#latest"
              className={
                "group flex items-center gap-3 px-4 py-3.5 transition-colors hover:bg-background-50 md:gap-4 md:px-6 " +
                (i !== hotRank.length - 1 ? "border-b border-background-200/80" : "")
              }
            >
              <span
                className={
                  "font-heading w-7 shrink-0 text-center text-xl font-black " +
                  (i < 3 ? "text-primary-500" : "text-foreground-400")
                }
              >
                {String(r.rank).padStart(2, "0")}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="truncate font-bold text-foreground-950 group-hover:text-primary-700">
                    {r.title}
                  </span>
                  <span className={"whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold " + badge[r.status]}>
                    {r.status}
                  </span>
                </div>
                <div className="mt-2 h-1.5 w-full max-w-[240px] overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-primary-500"
                    style={{ width: `${Math.max(12, (r.heat / 1000) * 100)}%` }}
                  ></span>
                </div>
              </div>

              <div className="flex shrink-0 flex-col items-end gap-0.5">
                <span className="flex items-center gap-1 whitespace-nowrap text-xs font-bold text-foreground-700">
                  <i className={"text-primary-500 " + trendIcon[r.trend]}></i>
                  {r.heat}
                </span>
                <span className="text-[11px] text-foreground-400">热度</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}